import type { GLSelectOptions } from '@group-link-one/gl-components';
import { useEffect, useState } from 'react';
import type { Tenant } from '@/Pages/BUs/BUManager/Components/BUPlatformList/BUPlatformList.types';
import { getTenants } from '@/Pages/BUs/BUManager/Services/BUPlatform.service';

export const useTenants = () => {
  const [tenants, setTenants] = useState<Tenant[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTenants = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const data = await getTenants();
        setTenants(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch tenants');
      } finally {
        setIsLoading(false);
      }
    };

    void fetchTenants();
  }, []);

  const tenantOptions: GLSelectOptions[] = tenants.map(t => ({
    id: t.id,
    text: t.name ?? t.slug,
    value: t.slug,
  }));

  return { tenants, tenantOptions, isLoading, error };
};
